var $944d06b741e38d3b$exports = {};
$944d06b741e38d3b$exports = {
    "collapse": `Samenvouwen`,
    "columnResizer": `Groottewijziging van kolom`,
    "drag": `Slepen`,
    "expand": `Uitvouwen`,
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`,
    "resizeColumn": `Kolomgrootte wijzigen`,
    "sortAscending": `Oplopend sorteren`,
    "sortDescending": `Aflopend sorteren`
};


export {$944d06b741e38d3b$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
